import { Suspense } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router } from 'react-router-dom';

import { Loading } from '@/components';
import { AppRoutes } from '@/routes';
import { stylesCenteredLoader } from '@/utils/globalStyles';

export function AppProvider() {
  return (
    <Suspense fallback={<Loading sx={stylesCenteredLoader} />}>
      <HelmetProvider>
        <Router>
          <AppRoutes />
        </Router>
      </HelmetProvider>
    </Suspense>
  );
}
